import React from 'react';
import cn from 'classnames';
import Scorecard from './Scorecard';
import './FullScreenScorecard.styl';
import {browserHistory} from 'react-router';
import ExtraReview from 'components/pure/scorecards/live-coaching/ExtraReview';
import debounce from 'lodash/debounce';
import CallCardActions from '@store/call-card/CallCardActions';

export default class FullScreenScorecard extends React.PureComponent {
  state = {
    navHeight: 200,
  };

  resizeHandler = debounce(() => this.setState({navHeight: this.navRef?.clientHeight ?? 200}), 100);

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  render() {
    const {model} = this.props;

    return (
      <div className={cn('full-screen-scorecard', {'new-call-card': this.props.newCallCard})}>
        <Scorecard
          newCallCard={this.props.newCallCard}
          navHeight={this.props.newCallCard ? 0 : this.state.navHeight}
          modelId={this.props.modelId}
          model={model}
          title={model ? model.callDetails.description : 'Scorecard'}
          scorecards={this.props.scorecards}
          sessionUser={this.props.sessionUser}
          isOwnCall={false}
          areScorecardResultsToggled={this.props.areScorecardResultsToggled}
          comments={this.props.comments}
          taggedUsers={this.props.taggedUsers}
          reasons={this.props.reasons}
          answers={this.props.answers}
          reasonSchemes={this.props.reasonSchemes}
          schemeLabels={this.props.schemeLabels}
          isSaving={this.props.isSaving}
          scorecardId={this.props.scorecardId}
          goBack={() => browserHistory.goBack()}
          readonly={this.props.readonly}
          extraReview={_ => <ExtraReview callId={this.props.modelId} isEditing={false} />}
          onSubmit={() => CallCardActions.getUserCallActivity.defer(this.props.fileUploadId)}
        />
      </div>
    );
  }
}
